/**
 * Advanced Tracking Helper v2.0
 * Handles Scroll, Rage Click, and Time on Page events.
 * Publishes custom events to Shopify Pixel via Shopify.analytics.publish().
 */

(function () {
    'use strict';

    const CONFIG = {
        rageClickThreshold: 3,
        rageClickWindow: 800, // ms
        rageClickRadius: 30,  // px
        scrollThresholds: [10, 25, 50, 75, 90]
    };

    // Safe publisher helper
    function publish(eventName, data) {
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
            window.Shopify.analytics.publish(eventName, data);
            console.log(`[TrackingHelper] Published ${eventName}`, data);
        }
    }

    // ==========================================
    // 1. SCROLL TRACKING
    // ==========================================
    let maxScroll = 0;
    let trackedScrolls = {};

    function handleScroll() {
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        if (docHeight <= 0) return;

        const scrollPercent = Math.round((window.scrollY / docHeight) * 100);
        if (scrollPercent > maxScroll) maxScroll = scrollPercent;

        CONFIG.scrollThresholds.forEach(thresh => {
            if (scrollPercent >= thresh && !trackedScrolls[thresh]) {
                trackedScrolls[thresh] = true;
                publish('custom_scroll', {
                    depth: thresh,
                    url: window.location.href,
                    title: document.title
                });
            }
        });
    }

    let ticking = false;
    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                handleScroll();
                ticking = false;
            });
            ticking = true;
        }
    }, { passive: true });

    // ==========================================
    // 2. RAGE CLICK TRACKING
    // ==========================================
    let clicks = [];

    document.addEventListener('click', (e) => {
        const now = Date.now();
        clicks.push({ x: e.clientX, y: e.clientY, time: now, target: e.target });
        clicks = clicks.filter(c => now - c.time < CONFIG.rageClickWindow);

        if (clicks.length >= CONFIG.rageClickThreshold) {
            const last = clicks[clicks.length - 1];
            const allClose = clicks.every(c => Math.hypot(c.x - last.x, c.y - last.y) < CONFIG.rageClickRadius);

            if (allClose) {
                const targetName = e.target.tagName
                    + (e.target.id ? '#' + e.target.id : '')
                    + (e.target.className && typeof e.target.className === 'string' ? '.' + e.target.className.split(' ')[0] : '');

                publish('custom_rage_click', {
                    x: e.clientX,
                    y: e.clientY,
                    target_element: targetName,
                    url: window.location.href
                });
                clicks = [];
            }
        }
    });

    // ==========================================
    // 3. TIME ON PAGE TRACKING
    // ==========================================
    const pageStartTime = Date.now();

    // Fires when user leaves or hides the tab/page
    function fireTimeOnPage() {
        const seconds = Math.round((Date.now() - pageStartTime) / 1000);
        // Only track if user spent at least 3 seconds on the page
        if (seconds < 3) return;

        publish('custom_time_on_page', {
            seconds: seconds,
            url: window.location.href,
            title: document.title,
            max_scroll_depth: maxScroll
        });
    }

    // Use visibilitychange (handles tab switch + close reliably)
    let timeFired = false;
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden' && !timeFired) {
            timeFired = true;
            fireTimeOnPage();
        }
    });

    // Fallback for browsers/cases that miss visibilitychange
    window.addEventListener('pagehide', () => {
        if (!timeFired) {
            timeFired = true;
            fireTimeOnPage();
        }
    });

    console.log('[TrackingHelper] v2.0 Initialized');
})();
